import { render } from "./JudgeProfile.vue?vue&type=template&id=37bb82a3"
import script from "./JudgeProfile.vue?vue&type=script&lang=js"
export * from "./JudgeProfile.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__